/**axios封装
  * 请求拦截、相应拦截、错误统一处理
  */
import axios from 'axios';
import QS from 'qs';
import md5 from 'js-md5';
let skey = 'gG2GgksqJPcQLXVTmbx7sxxnhO3Jgs'
console.log(process.env.NODE_ENV)
// 环境的切换
if (process.env.NODE_ENV == 'development') {
  console.log('测试环境哦')
  axios.defaults.baseURL = 'https://admins.medtrib.cn';
} else if (process.env.NODE_ENV == 'production') {
  console.log('正式环境')
  axios.defaults.baseURL = 'https://apps.medtrib.cn';
} else {
  console.log('本地环境')
  axios.defaults.baseURL = 'https://admins.medtrib.cn';
}
// 请求超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
  config => { return config },
  error => { return Promise.error(error) }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况    
  error => { }
);
/** 
* get方法，对应get请求 
* @param {String} url [请求的url地址] 
* @param {Object} params [请求时携带的参数] 
*/
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
function ruleParams (datas) {
  let params = {
    ...datas,
    sysImei: 0,
    sysDate: Date.parse(new Date()),
  };
  params.sysSign = md5(jsonSortToStr(params) + skey);
  return params;
};
//json转化为字符串
function jsonSortToStr (data) {
  var temp = [];
  for (let key in data) {
    temp.push(key + data[key]);
  }
  return temp.sort().join("");
}
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(ruleParams(params)))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}


// WEBPACK FOOTER //
// ./src/cmtapp/request/http.js